// extracted by mini-css-extract-plugin
module.exports = {"wrap":"CwToggleButton-wrap","inner":"CwToggleButton-inner","innerEnabled":"CwToggleButton-innerEnabled","innerActive":"CwToggleButton-innerActive"};